import { EnterpriseModel, EnterpriseResponse } from 'types';
import genericNormalizer from './generic';

export const normalizeEnterprise = genericNormalizer<
  EnterpriseResponse,
  EnterpriseModel
>(({ from }) => ({
  id: from('id'),
  name: from('name'),
  displayName: from('displayName'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/enterprise.ts